import { StyleSheet, View, Text } from "react-native";

import { getTimestampToDate, parseKeyValue, parseLocaleDatetime } from "../../../common/util";
import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-redir.svg';
import { ReactComponent as InfoImg } from '../../../img/ico-msg-info-2.svg';

import { ReactComponent as DeleteImg } from '../../../img/ico-prefix-close-gray.svg';

import { ReactComponent as DeploymentImg} from "../../../img/ico-vpc-list-deployment.svg";

import { ReactComponent as ActiveImg} from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-account-idle.svg";

import { ReactComponent as PodImg } from "../../../img/ico-prefix-pod.svg";
import { ReactComponent as PodActiveImg } from "../../../img/ico-prefix-pod.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { useNavigate } from "react-router-dom";
import { PAGE_URL } from "../../../value/Url";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import ListTable from "../../base/table/listTable";
import { actionMenus } from "./DeploymentPodData";
import { DeploymentPodData } from "./DeploymentData";



interface DeploymentDetailProps extends ContentContainerProps {

    detailData: DeploymentPodData;
    updateFunction: Function;
    clickActionMenu: Function;
    selectRow: Function;
    fetchData: any;
    pageCount: number;
    headers: any;
    tableData: any;
    totalItemCount: number;
    refreshYn: boolean;
    loadMainDataYn: boolean;
}

export default function DeploymentDetail(props:DeploymentDetailProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <ContentBox title={t("DEPLOYMENT_MGMT_TITLE")} subtitle={t("DEPLOYMENT_MGMT_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={{width: 1100}}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData?.update_ts ? parseLocaleDatetime(props.detailData?.update_ts) : "-"}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData?.create_ts ? parseLocaleDatetime(props.detailData?.create_ts) : "-"}
                        </Text>
                    </View>
                </View>

                <View>
                    <View style={{...style.boxContainer, height: "auto", minHeight: 550}}>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                            <Text style={style.boxContentTitleName}>
                                {props.detailData?.deployment_name}
                            </Text>
                            <div
                                style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                                onClick={() => {
                                    props.updateFunction();
                                }}
                            >
                                <TableEditImg/>
                                <Text style={{
                                    marginLeft: 2,
                                    fontFamily: FONT.MEDIUM,
                                    fontSize: 12,
                                    color: "#3c5df2"
                                }}>
                                    {t("INFO_EDIT_TEXT")}
                                </Text>
                            </div>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30, height: 54}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <Text style={style.boxContentDataText}>
                                {props.detailData?.deployment_description}
                            </Text>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("CLUSTER_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData?.container_cluster?.container_cluster_name}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", marginBottom: 30}}>
                                    <Text style={{...style.boxContentHeaderText}}>
                                        {t("NAMESPACE_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color:"#0853fb"}}>
                                        {props.detailData?.namespace?.namespace_name}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("PROJECT_TEXT")}
                            </Text>
                            <Text style={style.boxContentDataText}>
                                {props.detailData?.project?.project_name}
                            </Text>
                        </View>
                        <View style={style.boxContentDivLine}></View>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("DEPLOYMENT_COUNT_TEXT")}
                            </Text>
                            <Text style={{...style.boxContentDataText, color:"#3a8344"}}>
                                {props.detailData?.deployment_pod_count}
                            </Text>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("CONTAINER_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData?.container_count}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("VOLUME_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData?.volume_count}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={{...style.boxContentHeaderText, marginTop: 5}}>
                                {t("LABEL_TEXT")}
                            </Text>
                            {
                                <div style={{
                                     display: "flex", alignItems: "center", justifyContent: "center",
                                     minWidth: 20, height: 20,
                                     paddingLeft: 10, paddingRight: 10,
                                     marginRight: 4,
                                     borderRadius: 10,
                                     backgroundColor: "#e6ebf2",
                                     fontFamily: FONT.REGULAR,
                                     fontSize: 12,
                                     color: "#9ea0a5",
                                     marginBottom: 5
                                 }}>
                                 {props.detailData?.labels ? props.detailData?.labels : (t("EMPTY_TEXT"))}
                                </div>
                            }
                        </View>

                        <View style={{...style.innerItemContainer, flexDirection: "column", alignItems:"flex-start"}}>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}>Progressing Status</Text>
                                <View style={{ flexDirection: "row", alignItems: "center", width: 50}}>
                                    {
                                        props.detailData?.progressing_status_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.detailData?.progressing_status_yn ? "#3a8344" : "#8c8c8c",
                                    }}>
                                        {props.detailData?.progressing_status_yn ? "Up" : "Down"}
                                    </Text>
                                </View>
                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>{props.detailData?.progressing_status_reason}</Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                            <Text style={style.innerItemName}></Text>
                                <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15, marginLeft:80, color: "#8c9299", height: "100%", overflow:"visible"}}>{props.detailData?.progressing_status_message}</Text>
                            </View>
                            <View style={style.innerItemDivContainer}></View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}>Available Status</Text>
                                <View style={{ flexDirection: "row", alignItems: "center", width: 50}}>
                                    {
                                        props.detailData?.available_status_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.detailData?.available_status_yn ? "#3a8344" : "#8c8c8c",
                                    }}>
                                        {props.detailData?.available_status_yn ? "Up" : "Down"}
                                    </Text>
                                </View>
                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>{props.detailData?.available_status_reason}</Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                            <Text style={style.innerItemName}></Text>
                                <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15,marginLeft:80, color: "#8c9299", height: "100%", overflow:"visible"}}>{props.detailData?.available_status_message}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{...style.boxContainer, height: 720}}>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("INNER_POD_TEXT")}
                            </Text>
                        </View>
                        <View style={{marginTop: 24}}>
                            <ListTable
                                id={"deploymentPod"}
                                actionMenus={actionMenus}
                                actionMenuClickCb={props.clickActionMenu}
                                searchBarYn={true}
                                pageYn={true}
                                rowCheckYn={true}
                                rowCheckCb={props.selectRow}
                                fetchDataCb={props.fetchData}
                                pageCount={props.pageCount}
                                pageSize={20}
                                tableHeaders={props.headers}
                                tableData={props.tableData}
                                totalItemCount={props.totalItemCount}
                                detailYn={true}
                                refreshYn={props.refreshYn}
                                canLoadYn={true}
                            />
                        </View>
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitleName: {
        fontFamily: FONT.BOLD,
        fontSize: 20,
        color: "#494a4d"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentTitleDescription: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentDivLine: {
        height: 1,
        border: "solid 0.5px #eee", marginBottom: 30
    },
    innerItemEmtpyText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#4d5367"
    },
    innerItemEmptyImg: {
        width: 50,
        height: 50,
        marginRight: 30,
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {

    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 120,
        marginRight: 45,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        width: 50,
        fontFamily: FONT.BOLD,
        textAlign: "right",
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        width: 40,
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    innerItemContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        marginBottom: 30, marginTop: 10, minHeight: 80,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 0.8,
        borderColor: "#d2d5d9",
        paddingLeft: 30,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 20
    },
    innerItemName: {
        marginLeft: 10,
        width: 130,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerItemDivContainer: {
        marginTop: 15,
        marginBottom: 20,
        borderBottomColor: "#d2d5d9",
        borderBottomWidth: 0.5,
        width: "100%"
    },
    innerDataContainer: {
        marginLeft: 30,
        flexDirection: "row",
        alignItems: "center",
        width: 200,
        height: 36,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        paddingLeft: 20
    },
    innerItemBlueText: {
        width: 120,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#0853fb",
        overflow: "hidden",
    },
    innerItemText: {
        width: 80,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerItemResourceValueText: {
        marginLeft: 20,
        paddingRight: 5,
        width: 45,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#0853fb",
        overflow: "hidden",
    },
    innerColumnDivLine: {
        height: 18,
        borderColor: "#d2d5d9",
        borderStyle: "solid",
        borderWidth: 0.8
    },
    innerDataGreenText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#3a8344"
    },
    deploymentImgContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#b6bfce",
        opacity: 0.7,
        borderRadius: 10,
        marginRight: 15
    },
    deploymentImg: {
        opacity: 1
    }
});